// eslint-disable-next-line no-unused-vars
const searchForm = ( ( window, $ ) => {
	const init = () => {
		// const theBody = document.body;
		const siteHeader = document.querySelector( '.site-header' );
		const searchButton = document.querySelector( '.search-form-submit' );
		const searchFormInput = document.querySelector( '.search-form-input' );
		const navPrimary = document.querySelector( '.nav-primary' );

		// theBody.addEventListener( 'click', ( e ) => {
		// 	console.log( 'click', e.target.parentElement.classList );
		// 	if ( e.target.parentElement.classList.contains( 'search-form' ) ) {
		// 		siteHeader.classList.add( 'is-search-visible' );
		// 	} else {
		// 		siteHeader.classList.remove( 'is-search-visible' );
		// 	}
		// } );

		searchButton.addEventListener( 'click', ( e ) => {
			siteHeader.classList.toggle( 'is-search-visible' );
			navPrimary.classList.toggle( 'hidden' );
			if ( siteHeader.classList.contains( 'is-search-visible' ) ) {
				searchFormInput.focus();
			} else {
				searchFormInput.blur();
			}
			if (
				e.pointerType === 'touch' ||
				e.pointerType === 'click' ||
				e.pointerType === 'mouse'
			) {
				e.preventDefault();
			}
			// e.stopPropagation();
			// e.stopImmediatePropagation();
			// return false;
		} );
	};
	return {
		init,
	};
} )( window, jQuery );

export default searchForm;
